import {
  arrayOf,
  bool,
  number,
  object,
  oneOfType,
  shape,
  string,
} from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { formatAttachmentName, getShortDate } from "../../../helpers";

import Group from "../../form/components/Group";
import Label from "../../form/components/Label";

/**
 * Displays a selectable list of listing reports
 *
 * @param {string}   props.label
 * @param {array}    props.reports
 * @returns JSX
 * @public
 */
const ModalFilesReports = ({ label = "Reports", reports = [] }) => {
  if (!reports || !reports.length) {
    return null;
  }

  return (
    <Group>
      <Label as="p">{label}</Label>
      <Reports>
        {reports.map(report => (
          <li key={`report-public-${report.fileName}`}>
            {formatAttachmentName(report.fileTitle)}
            {!!report.fileDate && (
              <>
                {" "}
                <small>{getShortDate(report.fileDate)}</small>
              </>
            )}
          </li>
        ))}
      </Reports>
    </Group>
  );
};

const Reports = styled.ul`
  list-style: none;
  margin: 0;
  padding: ${rem("4px")} 0;

  li {
    margin-bottom: ${rem("6px")};
  }
`;

ModalFilesReports.propTypes = {
  label: string,
  reports: arrayOf(
    shape({
      fileDate: oneOfType([object, string]),
      fileId: oneOfType([number, string]),
      fileIndex: number,
      fileIsPublic: bool,
      fileName: string,
      fileTitle: string,
      fileType: string,
    })
  ),
};

export default ModalFilesReports;
